import React from 'react'
import PopupDialog from '@/components/popupDialog/PopupDialog'
import ListSelection, {
  ISelection,
} from '@/components/listSelection/ListSelection'

interface IPopupSelectProps {
  isOpen: boolean
  title: string
  selectedName: string
  selections: ISelection[]
  isLoading: boolean
  disabled?: boolean
  onClose: () => void
  onConfirm: (ids: number[]) => void
}

const PopupSelect: React.FC<IPopupSelectProps> = ({
  isOpen,
  title,
  selectedName,
  selections,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const alreadyExistIds = selections.reduce((ids, selection) => {
    if (selection.defaultSelected) {
      ids.push(selection.id)
      return ids
    }
    return ids
  }, [] as number[])
  const [selected, setSelected] = React.useState<number[]>(alreadyExistIds)

  return (
    <PopupDialog
      isOpen={isOpen}
      title={
        <>
          {title}: <b>{selectedName}</b>
        </>
      }
      isLoading={isLoading}
      content={
        <ListSelection
          selected={selected}
          selections={selections}
          onChange={(newSelected) => setSelected(newSelected)}
        />
      }
      onClose={onClose}
      onConfirm={() => onConfirm(selected)}
    />
  )
}

export default PopupSelect
